import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Mobile"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 3H7.5C6.67192 3.00083 6.00083 3.67192 6 4.5V21C6.00083 21.8281 6.67192 22.4992 7.5 22.5H16.5C17.3279 22.4988 17.9988 21.8279 18 21V4.5C17.9992 3.67192 17.3281 3.00083 16.5 3ZM16.5 4.5V6H7.5V4.5H16.5ZM7.5 21V7.5H16.5V21H7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Mobile.vue"]]);
